<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="true" :crubList="[{name:'金融合作伙伴管理'},{name:'附件资料管理',goback:true},{name:'新增附件资料'}]" :title="'新增附件资料'"/> -->
            <!-- 表单 -->
            <div class="box" v-loading="loading"
                element-loading-text="请求中......">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>协会简介：</div>
                        <div class="content">
                           <el-input type="textarea" :autosize="{ minRows: 4}" placeholder="限500字" v-model="sendInfo.intro" show-word-limit maxlength="500"></el-input>
                        </div>
                    </div>
                    <div class="error" v-if="errors['sendInfo.intro']">错误提示：{{errors['sendInfo.intro']}}</div>
                    <div class="child">
                        <div class="name"></div>
                        <div class="content">
                             <div class="singleBtn">
                      <el-button type="primary" size="small" @click="submit">发布</el-button>
                    </div>
                        </div>
                        
                    </div>
                    
                </div>
            </div>
        </div>
</template>

<script>
import {API} from "@/axios/config";
import breadcrumb from '../../components/breadcrumb';
import upLoadFiles from '../../components/upLoadFiles';
import wangEnduit from '../../components/Editor/index';
import {getDict} from "@/axios";
export default {
    components:{
        breadcrumb,
        upLoadFiles,
        wangEnduit
    },
    data(){
        return{
          loading:false,
            statusList: [],//服务类型
			id:'',
            sendInfo:{
                id:void 0,// ，编辑时必传
                intro: void 0
            },
            province:[],
			dict:{
				currentPage:1,
				direction:null,
				pageSize:10,
				parentId :1069409909080064,
				property:null,
			}
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
	created() {
		this.getDetail();
		
	},
    vuerify: {
		'sendInfo.intro':{
		    test:function(val){
		        if(val){
		            return true;
		        }else{
		            return false;
		        }
		    },
		    message:'请填写协会简介'
		}
    },
    methods:{
     
		getDetail(){
      this.loading = true
			this.$axiosc.get('/backstage/assIntro/findAssIntroDetails').then((r)=>{
			    if(r.code==200){
					    this.sendInfo=r.data
              this.loading = false
			    }else{
			        this.$alert(r.msg)
              this.loading = false
			    }
			}).catch(e=>{
        this.loading = false
      })
		},
        //提交
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
              this.$axioscBody.post('/backstage/assIntro/saveAssIntro',this.sendInfo).then((r)=>{
                if(r.code==200){
                  this.$message({
                    type: 'success',
                    message: r.msg
                  });
                  this.getDetail()
                }else{
                  this.$alert(r.msg);
                }
              })
            }
        },
        /** 富文本编辑器图片上传 */
    handleUploadEditor(file, callback) {
      const that = this
      const formData = new window.FormData()
      formData.append('file', file)
      // 上传 todu
      that.$axiosz.post(API.UploadsService + "backstage/annex/file", formData).then(res => {
        const {data,code,msg} = res
        if(code === 200){
        const { frontPath, filePath,fileName } = data
        const param = { ...data }
        param.name = fileName
        param.url = frontPath + filePath
        callback(param)
        }
      }).catch(e => {
        // that.$message.info('上传失败')
        that.$alert('上传失败')
        console.log(e)
      })
    },
    }
}
</script>

<style lang="scss" scoped>
.warp{
    height:100%;
    overflow: hidden;
    .box{
        
        padding-top:20px;
        height:calc(94% - 20px);
     overflow-x: hidden;
     overflow-y: auto;
        .forms{
            max-width: 750px;
            margin: auto;
            .child{
              align-items: flex-start;
                .content{
                    flex: 1;
					.el-textarea{
						width: 100% !important;
					}
                }
				/deep/ .el-select{
					width: 100% !important;
				}
				
				.name{
					width: 150px !important;
					text-align: right;
				}
            }
			.hint{
				padding-left: 100px;
			}
			.singleBtn{
				text-align: left;
			}
			.error{
				padding-left: 100px;
			}
        }
    }
}
</style>